import { createAction } from '@reduxjs/toolkit';
import type { ProfileSort } from '@shared/schemas';

import type { FilterGroup } from '@/types/filters';

/**
 * "Signal" actions: intents the UI dispatches for the saga to act on. Kept out of
 * the slice's reducers: they trigger the paginated fetch (a side effect), not the
 * state transitions (the saga owns the resulting `load*` / cursor transitions).
 */

/** Refetch the current page (after out-of-band mutations like add-tags). */
export const myProfilesRequested = createAction('myProfiles/myProfilesRequested');

/** The debounced, pruned server filters changed (resets to the first page). */
export const filtersChanged = createAction<FilterGroup | null>('myProfiles/filtersChanged');

/** The debounced keyword search changed (resets to the first page). */
export const searchChanged = createAction<string>('myProfiles/searchChanged');

/** "Ask AI": turn the sentence into filter rules (#567). */
export const aiSearchRequested = createAction<string>('myProfiles/aiSearchRequested');

/**
 * A sort arrow was clicked (#714): the server orders the whole list, and the
 * table goes back to its first page. Null = back to the default name order.
 */
export const sortChanged = createAction<ProfileSort | null>('myProfiles/sortChanged');

/** Navigate to a 0-indexed page. */
export const pageChanged = createAction<number>('myProfiles/pageChanged');

/** Change the page size (resets to the first page). */
export const pageSizeChanged = createAction<number>('myProfiles/pageSizeChanged');

/**
 * Load the category band's figures (#553). Dispatched on mount, and again after
 * anything that can change a profile's type, never on a filter change, which
 * does not move the population the band describes.
 */
export const categoryCountsRequested = createAction('myProfiles/categoryCountsRequested');

/**
 * Load the Country and Custom tags facets' choices (#615). Dispatched on mount,
 * and again after tags are added; a new tag must appear in the facet.
 */
export const facetOptionsRequested = createAction('myProfiles/facetOptionsRequested');
